function Logout()
{
    localStorage.clear();
    //const navigate = useNavigate();
    //navigate("/login");
    window.location.href = "./";
}

export default Logout;
